import React from 'react';
import './Legal.css';

const Tokutei = () => {
  return (
      <div className="legal-page">
        <div className="page-header">
          <div className="container">
            <h1>特定商取引法に基づく表記</h1>
          </div>
        </div>

        <section className="section">
          <div className="container">
            <div className="legal-content">
              <div className="legal-section">
                <table className="info-table">
                  <tbody>
                  <tr>
                    <th>販売業者</th>
                    <td>株式会社Gol-Pal</td>
                  </tr>
                  <tr>
                    <th>運営責任者</th>
                    <td>代表取締役社長　金子 聡美</td>
                  </tr>
                  <tr>
                    <th>所在地</th>
                    <td>〒150-0031 　東京都渋谷区桜丘町２３番１７号シティコート桜丘408</td>
                  </tr>
                  <tr>
                    <th>メールアドレス</th>
                    <td>info@gol-pal.com</td>
                  </tr>
                  <tr>
                    <th>販売価格</th>
                    <td>購入手続きの際に画面に表示されます。</td>
                  </tr>
                  <tr>
                    <th>商取等の引渡時期等</th>
                    <td>デジタルコンテンツは、購入手続の際に特別な定めを置いている場合を除き、購入手続完了後、直ぐにご利用いただけます。</td>
                  </tr>
                  <tr>
                    <th>お支払い方法</th>
                    <td>Apple Store / Google Play</td>
                  </tr>
                  <tr>
                    <th>キャンセル</th>
                    <td>購入手続完了後のお客様のご都合によるキャンセル（中途退会による場合も含みます）はできません。</td>
                  </tr>
                  </tbody>
                </table>
                <div className="legal-dates">
                  <p>2023/03/05 制定</p>
                  <p>2024/09/11 改定</p>
                  <p>2026/01/10 改定</p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
  );
};

export default Tokutei;